import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraTabs } from "../../../components/AtiraTabs";
import { Drawer } from "../../../components/Drawer";
import { Spacing } from "../../../theme/Spacing";
import { TasksReadTab } from "../../../components/tasks/TasksReadTab";
import { useDrawersContext } from "../../tasks/drawers-context";
import { TaskKind } from "../../../model/task/shared/TasksKind.enum";

const StyledTabs = styled(AtiraTabs)`
  margin-top: ${Spacing.m};

  .ant-tabs-nav::before {
    display: none;
  }

  .ant-tabs-nav-list {
    width: 100%;
    overflow-x: auto;
    gap: ${Spacing.s};
  }

  .ant-tabs-tab {
    flex-grow: 1;
    justify-content: center;
    margin-bottom: ${Spacing.xs} !important;
  }
`;

export const TasksReadDrawer: React.FC = () => {
  const { t } = useTranslation();
  const { tasksReadVisible, setTasksReadVisible, kanbanCard, setKanbanCard } =
    useDrawersContext();

  const localOnClose = () => {
    setTasksReadVisible(false);
    setKanbanCard(null);
  };

  return (
    <Drawer
      title={t("common.tasks")}
      open={tasksReadVisible}
      onClose={localOnClose}
      width={"35rem"}
    >
      {kanbanCard ? (
        <TasksReadTab kind={TaskKind.KANBAN} />
      ) : (
        <StyledTabs
          items={[
            {
              key: "lead",
              label: t("common.lead_tasks"),
              children: <TasksReadTab kind={TaskKind.LEAD} />,
            },
            {
              key: "contact",
              label: t("common.contact_tasks"),
              children: <TasksReadTab kind={TaskKind.CONTACT} />,
            },
          ]}
        />
      )}
    </Drawer>
  );
};
